<template>
  <div class="card mb-25 border-0 radius-7 bg-white stats-item card-realtime-custom-mobile">
    <div class="card-body p-15 p-sm-20 p-md-25 pt-lg-30 letter-spacing heigth-card-realtime align-items-center d-flex">
      <div class="row justify-content-between">
        <div class="col-lg-5 col-md-5 flex-card-custom">
          <div
            class="icon position-relative text-success rounded-1 text-center icon-realtime-custom-mobile"
          >
            <i class="flaticon-check-mark-1"></i>
          </div>

          <div class="flex-lg-column ml-10 info d-flex align-items-center text-cards-realtime custom-realtime-title-mobile">
            <span class="fs-13 d-block text-uppercase text-dark-emphasis fw-bold">
              UPLOADS COM SUCESSO
            </span>
            <div class="d-flex align-items-center width-100 mt-2 custom-realtime-title-mobile">
              <h4 class="fw-black mb-0 me-10 lh-1">{{ getCardsRealtime.total_success }}</h4>
            </div>
          </div>
        </div>

      </div>
      
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from 'vuex';

export default defineComponent({
  name: "UploadSuccessCard",

  data: function () {
    return {
      closed: [
        {
          name: "Hora",
          data: [7, 8, 9, 9, 8, 9, 8, 9, 11, 9, 8],
        },
      ],
      closedTicketsChart: {
        chart: {
          type: "area",
          toolbar: {
            show: false,
          },
        },
        colors: ["#159269"],
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: true,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          show: false,
        },
        grid: {
          show: false,
          strokeDashArray: 5,
          borderColor: "#dfe7f1",
        },
        tooltip: {
          enabled: true,
          style: {
            fontSize: "14px",
            fontFamily: "Red Hat Display, sans-serif",
          },
        },
      },
    };
  },
  computed:{
    ...mapGetters([
      'getCardsRealtime'
    ])
  },
});
</script>
